"use client";

import { type ReactNode } from "react";

import { Cards } from "~/components/cards";
import { TripCard } from "~/components/trip-card";

import { type TripCardTrip } from "./trip-cards-loader";

export function TripCards({
  title,
  trips,
}: {
  title: ReactNode;
  trips: TripCardTrip[];
}) {
  return <Cards items={trips} title={title} CardComponent={TripCard} />;
}
